import { ChevronDoubleUpIcon, EyeIcon, TrashIcon } from '@heroicons/react/24/outline'
import { formatTime } from 'utils'
import { renderHeader } from 'utils/table'

interface ExternalTicketsTableProps {
  values: any[]
  filters: Record<string, any>
  customFieldKeys: string[]
  offset: string | undefined
  onSort: (key: string, sortOrder: number) => void
  goToMessages: (value: any) => void
  onDelete: (ticket: any) => void
  onLoadMore: () => void
}

export const ExternalTicketsTable = ({
  values,
  filters,
  customFieldKeys,
  offset,
  onSort,
  goToMessages,
  onDelete,
  onLoadMore,
}: ExternalTicketsTableProps) => {
  return (
    <div className="table-container relative overflow-x-auto shadow-md sm:rounded-lg mb-6">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr className="font-variation-settings-600">
            <th scope="col" className="px-2 py-3 w-[40px]">
              No
            </th>

            {renderHeader({
              title: 'Subject',
              key: 'title',
              index: 2,
              onSort,
              sortable: true,
              sortOrder: filters.orderBy == 'title' ? parseInt(filters.orderDir) : 0,
            })}

            {customFieldKeys.map((fieldKey) => (
              <th key={fieldKey} scope="col" className="py-2 px-2">
                {fieldKey}
              </th>
            ))}

            {renderHeader({
              title: 'Created At',
              key: 'createdAt',
              index: 4,
              onSort,
              sortable: true,
              sortOrder: filters.orderBy == 'createdAt' ? parseInt(filters.orderDir) : 0,
            })}
            <th scope="col" className="px-2 py-3 w-[100px]">
              Action
            </th>
          </tr>
        </thead>

        <tbody className="text-[14px] text-gray-900">
          {values.map((value, index) => {
            return (
              <tr key={`${value.id}-${index}`} className={`border-b ${index % 2 && 'bg-slate-50'}`}>
                <td className="pl-3 py-3">{index + 1}</td>
                <td
                  className="font-variation-settings-600 text-shade-blue hover:underline cursor-pointer pl-3 py-3 text-base"
                  onClick={() => goToMessages(value)}
                >
                  {value.name}
                </td>
                {customFieldKeys.map((fieldKey) => {
                  const customField = value.custom_fields?.find((field: any) => field.name === fieldKey)
                  return (
                    <td key={fieldKey} className="px-2 py-2">
                      {customField?.display_value || ''}
                    </td>
                  )
                })}

                <td className="px-2 py-2">{formatTime(value.created_at)}</td>
                <td className="px-2 py-2">
                  <span className="flex gap-2">
                    <button
                      className="text-shade-blue hover-shadow1 cursor-pointer p-1"
                      onClick={() => goToMessages(value)}
                    >
                      <EyeIcon className="w-4 h-4"></EyeIcon>
                    </button>
                    <button
                      className="text-red-600 hover-shadow1 cursor-pointer p-1"
                      onClick={() => onDelete(value)}
                      title="Delete ticket"
                    >
                      <TrashIcon className="w-4 h-4"></TrashIcon>
                    </button>
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {offset && (
        <div className="my-2 text-gray-500 flex justify-center">
          <span className="flex gap-1 items-center cursor-pointer hover:animate-bounce py-2" onClick={onLoadMore}>
            <ChevronDoubleUpIcon className="w-4 h-4" />
            Load More
          </span>
        </div>
      )}
    </div>
  )
}
